import { TimeSlotsType } from '@features/tables/schemas/TablesAvailability.schema';

export function getPromotions(
  promotions: { id: number | string; name: string }[],
  timeSlot: TimeSlotsType[number],
  menuIds?: (number | string)[]
) {
  if (!timeSlot?.availablePromotions?.length || !promotions.length) {
    return [];
  }

  const menusAsString = menuIds?.map((menuId) => menuId.toString());

  const promotionsMap = new Map(promotions.map((p) => [String(p.id), p]));

  const timeSlotPromotions = timeSlot.availablePromotions
    .map((availablePromotion) => {
      const promotionData = promotionsMap.get(String(availablePromotion.id));
      if (promotionData) {
        return {
          value: {
            id: promotionData.id,
            timeslotReservationId: availablePromotion.timeslotReservationId,
          },
          label: promotionData.name,
        };
      }
      return undefined;
    })
    .filter(
      (
        p
      ): p is {
        value: { id: string; timeslotReservationId: string | undefined };
        label: string;
      } => p !== undefined
    );

  return menusAsString?.length
    ? timeSlotPromotions.filter((promo) => menusAsString.includes(promo.value.id.toString()))
    : timeSlotPromotions;
}
